import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import News from './components/News';
import Shop from './components/Shop';
import Ranking from './pages/Ranking';
import Navbar from './components/Navbar';
import Checkout from './pages/Checkout';
//import CartModal from './components/CartModal';
import OrderConfirmation from './pages/OrderConfirmation';
import Teams from './components/Teams';
import Fama from './pages/fama';
import Creators from './components/creators';
import Login from "./pages/login";
import Register from './pages/register';
import MyOrders from './pages/MyOrders';
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Success from "./pages/Success";
import Failure from "./pages/Failure";
import Pending from "./pages/Pending";
import Verified from "./pages/Verified";
import AdminDashboard from "./pages/AdminDashboard";
import NewsDetail from "./pages/NewsDetail";
import MyAccount from "./pages/MyAccount";
import AdminNews from "./pages/AdminNews";



function App() {
  const [cart, setCart] = useState([]); // Definir el estado global de `cart`

  return (
    <AuthProvider>
    <Router> 
      <Navbar />
      <Routes>
        <Route path="/" element={<Home cart={cart} setCart={setCart} />} /> {/* Página principal */}
        <Route path="/confirmacion" element={<OrderConfirmation />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<News />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="/fama" element={<Fama />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/news" element={<AdminNews />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/success" element={<Success />} />
        <Route path="/failure" element={<Failure />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/verified" element={<Verified />} />
        <Route path="/creators" element={<Creators />} />
        <Route path="/news/:slug" element={<NewsDetail />} />
        <Route
        path="/my-orders"
        element={
        <PrivateRoute>
        <MyOrders />
        </PrivateRoute>
        }
        />

        <Route
        path="/checkout"
        element={
        <PrivateRoute>
        <Checkout cart={cart} />
        </PrivateRoute>
        }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        

      </Routes>
    </Router>
    </AuthProvider>
  );
};

export default App;